// extracted by mini-css-extract-plugin
module.exports = {"root":"UserProfileLoader_root__3kfJp","errorNotification":"UserProfileLoader_errorNotification__3Vecl"};